import { LitElement, html, css, PropertyValues, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { IMOsCurrentScheduleState } from '../../../src/models/types/voyage-schedules-model.types';
import { VoyageSchedulesModel } from '../../../src/models/voyage-schedules-model';
import { GetFormattedDateDayMonthTimeNoYear, GetUTCTimestamp } from '../../../src/utils/helpers';
import { AlarmType,StaticInfoForAlarms } from '../../../src/services/types/fleet-alarms-service.types';
import { VoyFleetNotificationModel } from "../../../src/models/voy-fleet-notification-model";

@customElement('voy-vessel-progress-route')
export class VoyVesselProgressRoute extends LitElement {

    @property({ attribute: false }) imo?: number;
    @property({ attribute: false }) private _schedule?: IMOsCurrentScheduleState;

    constructor() {
        super()

        this.routeCompletionPercentage = this.routeCompletionPercentage.bind(this);
        this._renderReasonFromVessel = this._renderReasonFromVessel.bind(this)
    }

    static styles = css`
        :host {
            display: block;
        }
        .voyage-progress {
            height: 4px;
            width: 50%;
            background-color: var(--primary-blue-04);
            position: relative;
            display: block;
        }
       .voyage-progress-reasonGiven {
            height: 4px;
            width: 50%;
            background-color: var(--warning-yellow-8);
            position: relative;
            display: block;
        }
        .voyage-progress-delayed {
            height: 4px;
            width: 50%;
            background-color: var(--voyage-alarm-red);
            position: relative;
            display: block;
        }
        .voyage-progress[invalid] {
            background-color: var(--neutrals-grey-06);
        }
        /* Creates the small triangle on the progress bar end */
        .voyage-progress:after {
            content: "";
            display: inline-block;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 2px 0px 2px 3px;
            border-color: transparent transparent transparent var(--primary-blue-04);
            right: -3px;
            top: 0;
            position: absolute;
        }
    `;


    firstUpdated() {
        setInterval(() => { this.requestUpdate() }, 1000 * 60 * 1);
        if (!this.imo) return;
        this._updateSchedule();
    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has("imo")) {
            this._updateSchedule();
        }
    }

    routeCompletionPercentage(): number {
        if (!this._schedule || this._schedule.schedule.inPort) {
            return 100;
        }

        return Math.round(100 * (Date.now() - this._schedule.schedule.startTime) /
            (this._schedule.schedule.endTime - this._schedule.schedule.startTime));
    }

    render() {
        return html` <div data-test="voyage-progress" class="voyage-progress"  ?invalid=${!this._schedule} style=${`width: ${this.routeCompletionPercentage()}%`}>
            </div>`;
    }

    private _updateSchedule() {
        this._schedule = VoyageSchedulesModel?.currentScheduleStates?.find(s => s.imoNo === this.imo)
    }

    // Function to render the tooltip for schedule bar in list view and detail view.

    private _renderReasonFromVessel(etaDeviation: any) {
        let feedbackFromVessel = etaDeviation.notification_responses
        if(feedbackFromVessel && feedbackFromVessel.length){
            let parsedData = JSON.parse(feedbackFromVessel[0].data)
            return html`
               ${parsedData && parsedData.reason? html`<p class="alarm-body reason">Reason by vessel: ${GetUTCTimestamp(feedbackFromVessel[0]?.created_at||"")} UTC ${parsedData.reason}</p>  `: nothing }
               ${parsedData && parsedData.comments? html`<p class="alarm-body comment">Comment: ${parsedData.comments}</p>`: nothing }
             `
        }     
    }
}
